import type { Action } from 'redux';
import type { GetPinterestAuthenticationUrlPayload } from '../Pinterest.types';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import dash_api from '../../../../../main/support/dash_api';

const GetPinterestAuthenticationUrl = new ReduxAsyncAction<
  'GET_PINTEREST_AUTHENTICATION_URL',
  void,
  GetPinterestAuthenticationUrlPayload
>('GET_PINTEREST_AUTHENTICATION_URL');
GetPinterestAuthenticationUrl.registerRequest(() => {
  return dash_api.get('/v1/pinterest/get-auth-url').then(({ data }) => {
    return data;
  });
});
export const GET_PINTEREST_AUTHENTICATION_URL = GetPinterestAuthenticationUrl.actionNamespaceConstants;
export const getPinterestAuthenticationUrl = GetPinterestAuthenticationUrl.request;

export type GetPinterestAuthenticationUrlAction = Action<typeof GET_PINTEREST_AUTHENTICATION_URL.response> & {
  data: GetPinterestAuthenticationUrlPayload;
};
